import {ITheme} from 'contexts/ThemeContext';
import {Platform, StyleSheet, useWindowDimensions} from 'react-native';

export default ({colors, typography}: ITheme) => {
  const {width} = useWindowDimensions();

  return StyleSheet.create({
    containerStyle: {
      justifyContent: 'center',
      alignItems: 'center',
      paddingHorizontal: 8,
      paddingVertical: 3,
      borderRadius: 8,
      height: 22,
    },
    textStyle: {
      fontSize: 12,
      lineHeight: 19,
      ...typography.interRegular,
    },
    completedContainerStyle: {
      width: 96,
      backgroundColor: colors.narvik,
    },
    completedTextStyle: {
      color: colors.emerald,
    },
    errorContainerStyle: {
      width: 68,
      backgroundColor: colors.cinderella,
    },
    errorTextStyle: {
      color: colors.carnation,
    },

    cancelledContainerStyle: {
      width: 99,
      backgroundColor: colors.seashell,
    },
    cancelledTextStyle: {
      color: colors.rust,
    },
    inProgressContainerStyle: {
      width: 96,
      backgroundColor: colors.barleyWhite,
    },
    inProgressTextStyle: {
      color: colors.orangePeel,
    },
    notStartedContainerStyle: {
      width: 99,
      backgroundColor: colors.blackSqueeze,
    },
    notStartedTextStyle: {
      color: colors.lynch,
    },
  });
};
